
import Vue, { PropType } from 'vue';
import { Runnit, RUNNIT_NODE_DEF_TOOL_TYPE } from '@run-diffusion/shared';
import OfferingCard from '@/components/OfferingCard.vue';
import ManageRunnitMenuBtn from '@/views/Runnits/ManageRunnitMenuBtn.vue';
import RunnitBoardOwnerTableCell from './RunnitBoardOwnerTableCell.vue';

export default Vue.extend({
	name: 'RunnitBoardTile',
	props: {
		runnit: {
			type: Object as PropType<Runnit>,
			required: true,
		},
		// Added on this page and shown ahead of the listing (utils/justAdded.ts)
		justAdded: { type: Boolean, default: false },
		disabled: {
			type: Boolean,
			default: false,
		},
		disabledText: {
			type: String,
			default: null,
		},
		disabledCtaText: {
			type: String,
			default: null,
		},
		disabledCtaProps: {
			type: Object,
			default: () => ({}),
		},
		showEditBtn: {
			type: Boolean,
			default: true,
		},
		editText: {
			type: String,
			default: 'Manage Board',
		},
		buttonProps: {
			type: Object,
			default: null,
		},
		cardClass: {
			type: String,
			default: 'board-card',
		},
		runnitNodeDef: {
			type: Object,
			default: null,
		},
		horizontal: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TOOL_TYPE,
			isManageRunnitMenuOpen: false,
		};
	},
	components: {
		OfferingCard,
		ManageRunnitMenuBtn,
		RunnitBoardOwnerTableCell,
	},
});
